import AccountAccess from "./AccountAccessContainer";

export default AccountAccess;
